// src/components/organisms/Profile/ProfileChallengesSection.js

import React from "react";
import { Box, Typography, Grid, Link } from "@mui/material";
import ChallengeCard from "../../molecules/ChallengeCard"; // Import ChallengeCard

const ProfileChallengesSection = ({
  firstName,
  profileId,
  challenges,
  theme,
}) => {
  if (!challenges || challenges.length === 0) {
    return null; // Do not render anything if there are no challenges
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.colors.mediumBlue,
        borderRadius: "25px",
        padding: 4,
        paddingBottom: 0,
        mt: 4, // Add margin-top for spacing
      }}
    >
      {/* Full-width Row Above the Grid */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 4,
        }}
      >
        {/* Red Circle */}
        <Box
          sx={{
            width: 20,
            height: 20,
            backgroundColor: theme.colors.red,
            borderRadius: "50%",
            marginRight: 2,
          }}
        ></Box>

        {/* Vertical Line */}
        <Box
          sx={{
            width: 2,
            height: 40,
            backgroundColor: theme.colors.darkGray,
            marginRight: 2,
          }}
        ></Box>

        {/* User's First Name and Link */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "basic-sans",
              fontWeight: "normal",
              marginRight: 2,
              fontSize: "1.2em",
            }}
          >
            {firstName}'s Challenges
          </Typography>

          <Link
            href={`/challenge/profile/${profileId}/challenges`}
            underline="none"
            sx={{
              fontFamily: "basic-sans",
              fontWeight: "normal",
              marginRight: 2,
              fontSize: "1.2em",
              color: theme.colors.red,
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            View All
          </Link>
        </Box>
      </Box>

      {/* Grid of Challenge Cards */}
      <Grid container spacing={4}>
        {challenges.map((challenge) => (
          <Grid item xs={12} sm={6} md={4} key={challenge.id}>
            {/* Challenge Card */}
            <ChallengeCard challenge={challenge} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProfileChallengesSection;
